import { Color } from '../../constants'

export const CIRCLE_ANIMATION_DURATION = 300
export const CIRCLE_ANIMATION_DELAY = 10
export const CIRCLE_ANIMATION_DELAY_START = 300
export const CIRCLES_ANIMATE_ONCE = true

export const DEFAULT_LEGEND_ITEMS = [
  { name: '= 1 Initiative', fill: Color.Green },
  { name: '= 1 Movement Partner', fill: Color.Yellow },
]
